import React, { Children } from 'react';
import { useLocation, Link } from 'react-router-dom';

export const makeNavOption = Component => props => {
  const { pathname, search } = useLocation();
  const pathTokens = pathname.split('/');
  const valueTokens = props.value.split('/');
  const to =
    valueTokens
      .map((token, i) =>
        token.startsWith('*') ? pathTokens[i] || token.substring(1) : token,
      )
      .join('/') + search;

  return <Component {...props} component={Link} {...{ to }} />;
};

export function pathPatternMatch(path, pattern) {
  const pathTokens = path.split('/');
  const patternTokens = pattern.split('/');

  return patternTokens.every((patternToken, i) =>
    patternToken.startsWith('*')
      ? true
      : patternToken.startsWith('re:')
      ? new RegExp(patternToken.substring(3)).test(pathTokens[i])
      : patternToken === pathTokens[i],
  );
}

export const makeNavGroup = Component => ({ children, ...props }) => {
  const { pathname } = useLocation();
  const paths = Children.map(children, child => child?.props?.value).filter(
    Boolean,
  );
  const value = paths.find(pattern => pathPatternMatch(pathname, pattern));

  return (
    <Component {...{ value }} {...props}>
      {children}
    </Component>
  );
};

export const queryToSearch = query =>
  Object.entries(query)
    .filter(
      ([, value]) => value !== false && value !== 'null' && value !== '[]',
    )
    .map(([key, value]) => (value === true ? key : `${key}=${value}`))
    .join('&');

export const searchToQuery = search =>
  Object.fromEntries(
    search
      .substring(1)
      .split('&')
      .filter(param => param)
      .map(param => param.split('='))
      .map(([key, value = true]) => [
        key,
        typeof value === 'string' ? decodeURIComponent(value) : value,
      ]),
  );

export function useSearch() {
  const { search } = useLocation();
  return searchToQuery(search);
}
